type ModelViewerModule = typeof import('@ds-mgnl/marketing/model-viewer');

let modelViewerPromise: Promise<ModelViewerModule> | null = null;

export async function loadModelViewer() {
	if (!modelViewerPromise) {
		modelViewerPromise = Promise.all([
			import('@ds-mgnl/marketing/model-viewer'),
			// Must stay dynamic — a static CSS import defeats the code-split.
			import('@ds-mgnl/marketing/model-viewer.css'),
		])
			.then(([module]) => module)
			.catch((error) => {
				modelViewerPromise = null;
				throw error;
			});
	}

	return modelViewerPromise;
}
